import Moment from 'moment'

export default function monthName(value, format = 'MMM') {
  if (value) {
    return Moment(value, 'M').format(format)
  }
  return value
}
